import { APIDataRoom, APIMetaDataRoomPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'
export interface APIDataRoomOptions {
    roomMembersCanMessage: boolean
    roomManagersCanMessage: boolean
    roomMembersCanLeave: boolean
    roomManagersCanLeave: boolean
    roomManagersCanRemoveMembers: boolean
    roomManagersCanRemoveManagers: boolean
    roomManagersCanAddMembers: boolean
    roomManagersCanAddManagers: boolean
    roomManagersCanInviteMembers: boolean
    roomMembersCanInviteMembers: boolean
    departmentMembersCanJoinAsMember: boolean
    departmentManagersCanJoinAsMember: boolean
    departmentMembersCanJoinAsManager: boolean
    departmentManagersCanJoinAsManager: boolean
    autoAddDepartmentMembers: boolean
    departmentMembersCanReadMessages: boolean
    departmentManagersCanReadMessages: boolean
}

export interface APIDataRoomExtended extends Omit<APIDataRoom, 'options'> {
    options?: APIDataRoomOptions
    usersCount?: number
}

class RoomStore extends Store<APIDataRoomExtended> {

    // override update(...args: Parameters<Store<APIDataRoomExtended>['update']>) {
    //     console.log('🎄🎄🎄🎄🎄', JSON.stringify(args, null, 4))
    //     super.update(...args)
    // }

    constructor() {
        super([...APIMetaDataRoomPropertyNames, 'integrationAcl', 'usersCount'])
    }
}

decorate(injectable(), RoomStore)

export { RoomStore }
